var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"alert-fixed mt-3 col-sm-8 offset-sm-2",attrs:{"variant":_vm.variant,"dismissible":"","fade":"","show":_vm.show},on:{"dismissed":_vm.dismiss}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }